import React from 'react';
import { Button, Offcanvas } from 'react-bootstrap';
import CopilotChat from './Copilot/CopilotChat';

const AiBriefingPopup = ({ show, onHide }) => {
    return (
        <Offcanvas
            show={show}
            onHide={onHide}
            placement="end"
            style={{ width: '400px', borderLeft: 'none' }}
            className="shadow-lg border-0 bg-body text-body"
        >
            <div className="d-flex flex-column h-100">
                {/* Header */}
                <div className="bg-primary text-white d-flex justify-content-between align-items-center py-2 px-3 flex-shrink-0">
                    <div className="d-flex align-items-center">
                        <div className="bg-white bg-opacity-25 rounded-4 d-flex align-items-center justify-content-center me-2" style={{ width: '36px', height: '36px' }}>
                            <i className="bi bi-stars text-warning fs-5"></i>
                        </div>
                        <div className="text-start">
                            <h6 className="mb-0 fw-bold text-white">KITbot Copilot 2.0</h6>
                            <small className="text-white-50" style={{ fontSize: '0.7rem' }}>AI CRM Action Copilot (Beta)</small>
                        </div>
                    </div>
                    <Button variant="link" className="text-white p-0" onClick={onHide} title="ปิดหน้าต่าง">
                        <i className="bi bi-x-lg fs-5"></i>
                    </Button>
                </div>

                {/* Copilot Chat Body (V2 Only) */}
                <div className="flex-grow-1 overflow-hidden d-flex flex-column position-relative bg-body">
                    <CopilotChat />
                </div>

                {/* Footer */}
                <div className="bg-body border-top py-2 text-center flex-shrink-0">
                    <small className="text-secondary" style={{ fontSize: '0.7rem' }}>
                        KITbot Copilot 2.0 • Real-time AI Assistant
                    </small>
                </div>
            </div>
        </Offcanvas>
    );
};

export default AiBriefingPopup;
